import { fetchProductsBySearch } from '../../services/product-api';

// Shared by the results page and the search box (which starts this request on
// submit, while the results page is still loading) so both hit one cache entry.
export const searchProductsQuery = (query, page = 1) => ({
  queryKey: ['products-by-search', query, page],
  queryFn: ({ signal }) => fetchProductsBySearch(query, page, { signal }),
});

// Normalised form used in the URL and cache keys
export const normaliseSearchQuery = (value = '') => value.trim().toLowerCase();
